import React from 'react';
import { Route, Routes } from 'react-router-dom';
//import DisplayOrders from '../znotusedcurrently/orders/orders/DisplayOrders.jsx2';
//import DisplayPositions from '../znotusedcurrently/positions/positions/DisplayPositions.jsx2';
//import TradePlanView from '../znotusedcurrently/tradeplans/TradePlanView.jsx2';
//import DisplayNotifications from '../components/displays/notifications/notificationtable/DisplayNotifications';
//import UpdateSavedTradePlanConfig from '../components/forms/tradeplans/SavedTradePlanConfig/UpdateTpConfig.jsxunused';
//import RemoveTradePlanConfigForm from '../components/forms/tradeplans/SavedTradePlanConfig/RemoveSavedTpConfig.jsxunused';
//import TradePlanForm from '../components/forms/tradeplans/AddTradePlan/tradePlanForm/TradePlanForm';
import { AppMainPage } from '../components/displays/contextmenu/AppMainPage';
import TradeHistoryForm from '../components/displays/tradehistory/TradeHistoryForm';
import { AlertsMainPage } from '../components/displays/alerts/alertsMainPage/AlertsMainPage';
import { Main } from '../components/displays/newTradingInterface/newMainPage/Main';
import { LoginForm } from '../components/forms/auth/LoginForm';
import { ForgotPasswordForm } from '../components/forms/auth/ForgotPasswordForm';
import { ResetPasswordForm } from '../components/forms/auth/ResetPasswordForm';
import { ProtectedRoute } from '../components/routing/ProtectedRoute';

const routes = {};
instantiateRoutes();

export function createRoute(path, component) {
  if (routes[path] === undefined) {
    routes[path] = <Route path={path} component={component} exact={true} />;
  }
  //return routes[path];
}

export function removeRoute(path) {
  delete routes[path];
}

export default function GenerateRoutes() {
  return <Routes>{Object.values(routes).map((route) => route)}</Routes>;
}

function instantiateRoutes() {
  routes['login'] = (
    <Route key="/login" path="/ui/login" element={<LoginForm/>} exact={true} />
  );

  routes['forgotPassword'] = (
    <Route key="/forgot-password" path="/ui/forgot-password" element={<ForgotPasswordForm/>} exact={true} />
  );

  routes['resetPassword'] = (
    <Route key="/reset-password" path="/ui/reset-password" element={<ResetPasswordForm/>} exact={true} />
  );

  routes['/'] = (
    <Route key="/" path="/ui/" element={
      <ProtectedRoute>
        <AppMainPage/>
      </ProtectedRoute>
    } exact={true} />
  );

  routes['tradeHistory'] = (
    <Route
      key="/tradeHistory"
      path="/ui/tradeHistory"
      element={
        <ProtectedRoute>
          <TradeHistoryForm/>
        </ProtectedRoute>
      }
      exact={true}
    />
  );

  routes['alerts'] = (
    <Route
      key="/alerts"
      path="/ui/alerts"
      element={
        <ProtectedRoute>
          <AlertsMainPage/>
        </ProtectedRoute>
      }
      exact={true}
    />
  );

  routes['trading'] = (
    <Route
    key="/trading"
    path="/ui/trading"
    element={
      <ProtectedRoute>
        <Main/>
      </ProtectedRoute>
    }
    exact={true}
  />
  )

  return routes;
}
